<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre4">
<p class="dedication">To my family of ice and lightning.</p>
<p class="body"><span>Without you, none of this would be possible.</span><span></span></p>
<p class="body1"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// LovesickGods_eBook1_011.vue?3959b8c1